var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAffogatoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_845_923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3637 0.636368H11.4546V8.81819H16.3637C20.8833 8.81819 24.5455 12.4804 24.5455 17V21.9091H32.7273V17C32.7273 7.964 25.3997 0.636368 16.3637 0.636368Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2727 33.3636V25.1818H16.3636C11.844 25.1818 8.18182 21.5196 8.18182 17V12.0909H0V17C0 26.036 7.32764 33.3636 16.3636 33.3636H21.2727Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_845_923"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.7273,
    height: 32.7273,
    fill: "white",
    transform: "translate(0 0.636368)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffogatoLogo);
export default __webpack_public_path__ + "static/media/affogato-logo.0a03056565819a57de94bc3721fbfc14.svg";
export { ForwardRef as ReactComponent };